<template>
  <div class="box">
    <el-collapse>
      <el-collapse-item title="内容" name="1">
        <ul class="settingUl">
          <li>
            <span>标题内容</span>
            <input style="width: 200px;" id="title" v-model="data.title" />
          </li>
        </ul>
      </el-collapse-item>
      <el-collapse-item title="内容样式" name="2">
        <ul class="settingUl">
          <li>
            <span>标题颜色</span>
            <el-color-picker v-model="data.conStyle.titleColor"></el-color-picker>
          </li>
          <li>
            <span>大小({{ data.conStyle.titleSize }})</span>
            <el-radio-group v-model="data.conStyle.titleSize" size="mini">
              <el-radio-button label="14">小</el-radio-button>
              <el-radio-button label="16">中</el-radio-button>
              <el-radio-button label="18">大</el-radio-button>
            </el-radio-group>
          </li>
          <li>
            <span>加粗</span>
            <el-radio-group v-model="data.conStyle.titleBold" size="mini">
              <el-radio-button label="是"></el-radio-button>
              <el-radio-button label="否"></el-radio-button>
            </el-radio-group>
          </li>
          <li>
            <span>对齐方式</span>
            <el-radio-group v-model="data.conStyle.titleAlign" size="mini">
              <el-radio-button label="居左"></el-radio-button>
              <el-radio-button label="居中"></el-radio-button>
            </el-radio-group>
          </li>
          <li>
            <span>查看更多</span>
            <el-radio-group v-model="data.conStyle.moreType" size="mini">
              <el-radio-button label="无"></el-radio-button>
              <el-radio-button label="图标"></el-radio-button>
              <el-radio-button label="文字"></el-radio-button>
              <el-radio-button label="图文"></el-radio-button>
            </el-radio-group>
          </li>
          <li v-if="data.conStyle.moreType !== '图标' && data.conStyle.moreType !== '无'">
            <span>文字</span>
            <el-input style="width: 150px;" size="mini" v-model="data.conStyle.moreText"></el-input>
          </li>
          <li v-if="data.conStyle.moreType !== '无'">
            <span>图文颜色</span>
            <el-color-picker v-model="data.conStyle.moreColor"></el-color-picker>
          </li>
          <li v-if="data.conStyle.moreType !== '无'">
            <span>链接</span>
            <el-dropdown @command="handleLinkItem">
              <span class="el-dropdown-link">
                {{ data.link }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(link, idx) in data.linkList" :key="idx" :command="`${link.title}#${link.page}`">
                  {{ link.title }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>

      </el-collapse-item>
      <el-collapse-item title="组件样式" name="3">
        <comSetting :infoItme="data.infoItme" />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import comSetting from '../comSetting'
export default {
  name: 'TitleSetting',
  components: { comSetting },
  props: {
    data: Object
  },
  methods: {
    handleLinkItem (command) {
      const idx1 = command.indexOf('#')
      const pagetit = command.substring(0, idx1)
      const page = command.substring(idx1 + 1)
      this.data.link = pagetit
      this.data.page = page
    }
  }
}
</script>
<style scoped>
label {
  font-size: 13px;
}

.box {
  text-align: center;
  padding-top: 20px;
}

#title {
  width: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/title/TitleSetting.vue